<template>
	<nav
		class="container flex my-4 lg:my-6 whitespace-nowrap"
		aria-label="Breadcrumb"
	>
		<ol class="inline-flex items-center overflow-x-auto pb-2 -mb-2">
			<li class="items-center">
				<NuxtLink
					:to="localePath('/')"
					class="text-gray-500 inline-flex items-center text-xs lg:text-sm font-medium"
				>
					{{ $t("Home") }}
				</NuxtLink>
				<span
					class="font-medium ml-2 mr-2 w-5 h-5 text-center text-sm text-gray-300"
					>/
				</span>
			</li>
			<li
				v-for="(crumb, index) in getBreadcrumbs"
				:key="index"
				class="inline items-center"
			>
				<NuxtLink
					:to="localePath(crumb.path)"
					:class="`inline items-center text-xs lg:text-sm font-medium text-gray-500 ${
						!crumb.path.length ? 'cursor-default' : ''
					}`"
				>
					{{ crumb.name }}
				</NuxtLink>
				<span
					v-if="index < getBreadcrumbs.length - 1"
					class="inline font-medium ml-2 mr-2 w-5 h-5 text-center text-sm text-gray-300"
					>/
				</span>
			</li>
		</ol>
	</nav>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";

const pageStore = usePageStore();

const { pageTitle, pageType, categoryBreadcrumb } = storeToRefs(pageStore);

const { iterateOverCategoryDetails } = useCategory();
const localePath = useLocalePath();

const getBreadcrumbs = computed(() => {
	const breadcrumbs = [];

	if (
		(pageType.value === "category" || pageType.value === "product") &&
		categoryBreadcrumb?.value
	) {
		let currentCategory:
			| BreadcrumbsCategory
			| Partial<BreadcrumbsCategory>
			| null
			| undefined = JSON.parse(JSON.stringify(categoryBreadcrumb.value));

		while (currentCategory) {
			breadcrumbs.unshift({
				name: currentCategory.Name || "",
				path: `/category/${iterateOverCategoryDetails(currentCategory)}`
			});
			currentCategory = currentCategory.Parent;
		}

		if (pageType.value === "product") {
			breadcrumbs.push({
				name: pageTitle.value,
				path: ""
			});
		}
	} else {
		breadcrumbs.push({
			name: pageTitle.value,
			path: ""
		});
	}

	return breadcrumbs;
});

useSchemaOrg([
	defineBreadcrumb({
		itemListElement: getBreadcrumbs.value.map((crumb, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: crumb.name,
			item: crumb.path ? localePath(crumb.path) : undefined
		}))
	})
]);
</script>
